import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "customer-edit-profile profile-with-tickets" }
const _hoisted_2 = { class: "project-tickets-section" }
const _hoisted_3 = { class: "project-tickets-list" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "empty-state",
  style: {"text-align":"center","margin-top":"20px"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "pro-t-l-content" }
const _hoisted_10 = {
  key: 0,
  class: "pagination-box"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "edit-profile-pages" }
const _hoisted_13 = { class: "edit-profile-in" }
const _hoisted_14 = { class: "edit-profile-in-l" }
const _hoisted_15 = { class: "user-pro-img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "active" }
const _hoisted_18 = { class: "edit-profile-in-r" }
const _hoisted_19 = { class: "input-row-2" }
const _hoisted_20 = { class: "v1-input-field" }
const _hoisted_21 = { class: "v1-input-field" }
const _hoisted_22 = { class: "input-row-2" }
const _hoisted_23 = { class: "v1-input-field" }
const _hoisted_24 = { class: "v1-input-field" }
const _hoisted_25 = { class: "input-row-2" }
const _hoisted_26 = { class: "v1-input-field" }
const _hoisted_27 = { class: "v1-input-field" }
const _hoisted_28 = { class: "input-row-2" }
const _hoisted_29 = { class: "v1-input-field" }
const _hoisted_30 = { class: "contact-input-group" }
const _hoisted_31 = { class: "v1-input-field" }
const _hoisted_32 = { class: "input-row" }
const _hoisted_33 = { class: "v1-input-field" }
const _hoisted_34 = {
  id: "showclone",
  class: "employee-add-project"
}
const _hoisted_35 = { class: "v1-input-field" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "v1-input-field" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "more-pro-btn" }
const _hoisted_41 = { class: "input-submit" }
const _hoisted_42 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.constants.TICKETS_CREATED_BY_ME_TEXT), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.createdLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("div", { class: "loading-spinner" }, "Loading tickets...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.createdTickets.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No ticket is created "))
                : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdTickets, (issue) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: issue.id
                      }, [
                        _createVNode(_component_router_link, {
                          to: `/employee/issue-detail/${issue.key}`,
                          id: "ticketLink"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: issue.fields.issuetype?.iconUrl,
                                alt: ""
                              }, null, 8, _hoisted_8)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("strong", null, _toDisplayString(issue.key), 1),
                              _createElementVNode("p", null, _toDisplayString(issue.fields.summary), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
            ]))
      ]),
      (_ctx.createdTotalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("ul", null, [
              (_ctx.createdCurrentPage !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "pagination-first",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCreatedPage(_ctx.createdCurrentPage - 1)))
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("button", { id: "paginationFirstButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdVisiblePages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  onClick: ($event: any) => (_ctx.changeCreatedPage(page))
                }, [
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass({ active: _ctx.createdCurrentPage === page })
                  }, _toDisplayString(page), 3)
                ], 8, _hoisted_11))
              }), 128)),
              (_ctx.createdCurrentPage !== _ctx.createdTotalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "pagination-last",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCreatedPage(_ctx.createdCurrentPage + 1)))
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("button", { id: "paginationLastButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.constants.EDIT_PROFILE_LINK), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: _ctx.displayImage,
              width: "100%",
              alt: "Profile Image"
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(_ctx.fullName) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.userProfileData.designation), 1)
          ]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("input", {
                type: "file",
                id: "fileUploadInput",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                accept: "image/*"
              }, null, 32),
              _createElementVNode("span", null, _toDisplayString(_ctx.constants.UPLOAD_PICTURE_LABEL), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                "data-bs-toggle": "modal",
                "data-bs-target": "#deleteProfileimg",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteProfileImage && _ctx.deleteProfileImage(...args)))
              }, _toDisplayString(_ctx.constants.DELETE_PICTURE_LINK), 1)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: '/employee/profile',
                id: "viewProfileLink"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.constants.VIEW_PROFILE_LINK), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: '/employee/edit-profile',
                id: "editProfileLink"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.constants.EDIT_PROFILE_LINK), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("form", {
            onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.FIRST_NAME_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "firstNameInput",
                  type: "text",
                  placeholder: "Enter first Name",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userProfileData.firstName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.LAST_NAME_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "lastNameInput",
                  type: "text",
                  placeholder: "Enter last Name",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userProfileData.lastName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_ADDRESS_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "emailInput",
                  type: "text",
                  placeholder: "Enter email address",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userProfileData.email) = $event)),
                  readonly: true
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.EDUCATION_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Enter education",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userProfileData.education) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.education]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.COMPANY_NAME_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "companyNameInput",
                  type: "text",
                  placeholder: "Enter company name",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userProfileData.comapanyName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.comapanyName]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.COMPANY_WEBSITE_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "companyWebsiteInput",
                  type: "text",
                  placeholder: "Enter company website",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userProfileData.websiteUrl) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.websiteUrl]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.CONTACT_NO_LABEL), 1),
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "contact-number",
                    name: "contact-number",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userProfileData.contactNumber) = $event)),
                    placeholder: "Enter phone number"
                  }, null, 512), [
                    [_vModelText, _ctx.userProfileData.contactNumber]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.DEFAULT_ROLE_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Enter default role",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userProfileData.designation) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.designation]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.ABOUT_ME_LABEL), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userProfileData.aboutUs) = $event)),
                  id: "avoutMeInput",
                  class: "height-150",
                  placeholder: "Enter about me"
                }, null, 512), [
                  [_vModelText, _ctx.userProfileData.aboutUs]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userProfileData.projects, (project, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "clone",
                  class: "input-row-2",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.constants.PROJECT_LABEL), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "v1-selectbox",
                      "onUpdate:modelValue": ($event: any) => ((project.name) = $event)
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("option", {
                        value: "",
                        disabled: "",
                        selected: ""
                      }, "Select a project", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableProjects, (availableProject, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: availableProject.name
                        }, _toDisplayString(availableProject.name), 9, _hoisted_37))
                      }), 128))
                    ], 8, _hoisted_36), [
                      [_vModelSelect, project.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESIGNATION_LABEL), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Enter designation",
                      "onUpdate:modelValue": ($event: any) => ((project.role) = $event)
                    }, null, 8, _hoisted_39), [
                      [_vModelText, project.role]
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                type: "button",
                id: "cloneadd",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addMoreProject && _ctx.addMoreProject(...args)))
              }, _toDisplayString(_ctx.constants.ADD_MORE_PROJECT_BUTTON), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "button",
                class: "v1-button-outline-black",
                id: "cancelBtn",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
              }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "v1-button-outline",
                id: "updateBtn",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? "Updating..." : _ctx.constants.UPDATE_BUTTON), 9, _hoisted_42)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}